'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>搜索页</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 - </router-link><a>搜索</a>

         <div class="header_right">
            <input type="text" v-model="searchText" name="searchText" placeholder="输入关键词" @keyup.enter="goSearch" @blur="goSearch">
            <button type="button" @click="goSearch">搜索</button>
         </div>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item" :class="typeActive == 1 ?'active':''" @click="changeLeft(1)">
                     <a href="javascript:;">
                        资讯 <span class="iconfont">&#xe610;</span>
                     </a>
                  </div>
                  <div class="l_nav_item" :class="typeActive == 2 ?'active':''" @click="changeLeft(2)">
                     <a href="javascript:;">
                        直播 <span class="iconfont">&#xe610;</span>
                     </a>
                  </div>
               </div>
            </div>
            <div class="list_right" v-loading="loading">
               <template v-if="list.length > 0">
                  <template v-if="typeActive == 1">
                     <ul class="right_list">
                        <li v-for="(item,index) in list">
                           <router-link :to="'/list/'+item.parentCategoryCode+'/info/'+item.code+'?rCode='+item.code">
                              <h5 class="l_title">{{item.title}}</h5>
                              <span class="l_date">{{(item.createTime).slice(0,10)}}</span>
                           </router-link>
                        </li>
                     </ul>
                  </template>
                  <template v-else>
                     <div class="right_livelist">
                        <ul>
                           <li v-for="(item,index) in list">
                              <div class="imgbox">
                                 <router-link :to="'/live/info/'+item.code"><img :src="item.photo" alt=""></router-link>
                              </div>
                              <div class="right_info">
                                 <h5>
                                    <router-link :to="'/live/info/'+item.code">{{item.title}}</router-link>
                                 </h5>
                                 <div class="right_date">
                                    <div class="date_col">
                                       <span>讲师：{{item.lecturer != null ?item.lecturer:'--'}}</span>
                                    </div>
                                    <div class="date_col">
                                       <span>时间：{{item.beginTime}} - {{item.endTime}}</span>
                                    </div>
                                    <div class="date_col">
                                       <span>&nbsp;</span>
                                       <!--type1 直播中 type2 未开播-->
                                       <span class="status" :class="[item.liveStatus == 5?'type1':'',item.liveStatus == 9?'type2':'',item.liveStatus == 1?'type2':'']">{{item.liveStatusName}}</span>
                                    </div>
                                 </div>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </template>
                  <div class="list_pages">
                     <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount" @current-change="handleCurrentChange">
                     </el-pagination>
                  </div>
               </template>
               <el-empty description="暂无内容" v-else></el-empty>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            loading: true,
            typeActive: 1, // 1 资讯 2 直播
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,
            list: [],
            searchText:'',
         };
      },
      watch: {
         $route() {

         },
         '$route.query.searchText': {
            handler(newVal, oldVal) {
               this.searchText = this.$route.query.keyword;
               this.pageNum = 1;
               this.getlist();
            },
            deep: true
         }
      },
      mounted() {
         this.searchText = this.$route.query.keyword;
         this.getlist();
      },
      methods: {
         getlist() {
            var _this = this,
               code = '';
            _this.loading = true;
            if(this.typeActive == 1){
            if (this.rCode != '') {
               code = this.rCode;
            } else {
               code = this.typeCode;
            }
            _this.$api.artList({
               keyword:_this.searchText,
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
            }else{
               _this.$api.liveList({
                  title:_this.searchText,
                  pageNum: _this.pageNum,
                  pageSize: _this.pageSize
               }).then(res => {
                  _this.loading = false;
                  if (res.code == 200) {
                     _this.list = res.data.list;
                     _this.pagecount = res.data.total;
                  } else {
                     _this.$message.error(res.msg);
                  }
               }).catch(function(error) {
                  _this.loading = false;
                  _this.$message.error(error.msg);
               });
            }
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         },
         changeLeft(type){
            this.pageNum = 1;
            this.typeActive = type;
            this.getlist();
         },
         goSearch(){
            this.pageNum = 1;
            this.getlist();
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
